import FilterIcon from "theme/components/icons/FilterIcon";
import SortIcon from "theme/components/icons/SortIcon";
import TextStyles from "theme/components/text/TextStyles";
import styled from "theme/libs/styled";
import { useTranslation } from "react-i18next";

const FilterBar = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
`;

const FilterButton = styled("div")`
    display: flex;
    align-items: center;
`;
const LeftSide = styled("div")`
    display: flex;
    align-items: center;
`;

const ProductGrid = () => {
    const { t } = useTranslation();

    return (
        <FilterBar>
            <FilterButton>
                <TextStyles textStyles="Buenos Aires/16-120 Regular" mr="4px">
                    {t("filter.button_closed")}
                </TextStyles>
                <FilterIcon />
            </FilterButton>
            <LeftSide>
                <TextStyles textStyles="Buenos Aires/16-120 Regular" mr="4px">
                    {t("filter.sort")}
                </TextStyles>
                <SortIcon />
            </LeftSide>
        </FilterBar>
    );
};

export default ProductGrid;
